import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import Logo from '../../images/site_logo/Nimanode.png'
// import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {

    const [mobailActive] = useState(false);

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (

        <header className={`site_header  ${isSticky ? 'sticky' : ''}`}>
            <div className="nav_wrapper">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-5 d-flex align-items-center">
                            <div className="site_logo">
                                <NavLink className="site_link" to="/" onClick={ClickHandler}>
                                    <img loading="lazy" src={Logo} alt="Site Logo" width={200} />
                                </NavLink>
                            </div>
                        </div>
                        <div className="col-lg-5 col-2">
                            <nav className="main_menu navbar navbar-expand-lg">
                                <div className={`main_menu_inner collapse navbar-collapse justify-content-center ${mobailActive ? 'show' : ''}`} id="main_menu_dropdown">
                                    <ul className="main_menu_list unordered_list text-uppercase main-menu">
                                        <li className="dropdown">
                                            <Link to="id_ico_features_section" spy={true} smooth={true} duration={500} offset={-100} className="nav-link scrollspy_btn">
                                                <span className="nav_link_label" data-text="Features">Features</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="id_ico_token_section" spy={true} smooth={true} duration={500} offset={-100} className="nav-link scrollspy_btn">
                                                <span className="nav_link_label" data-text="Token">Token</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="id_ico_roadmap_section" spy={true} smooth={true} duration={500} offset={-100} className="nav-link scrollspy_btn">
                                                <span className="nav_link_label" data-text="Roadmap">Roadmap</span>
                                            </Link>
                                        </li>
                                        <li className="dropdown">
                                            <a href="https://docs.nimanode.com/" target='_blank' rel='noreferrer' className="nav-link scrollspy_btn">
                                                <span className="nav_link_label" data-text="Docs">Docs</span>
                                            </a>
                                        </li>
                                    </ul>
                                    {/* <MobileMenu/> */}
                                </div>
                            </nav>
                        </div>
                        <div className="col-lg-2 col-5">
                            <ul className="btns_group unordered_list p-0 justify-content-end">
                                {/* <li className="d-lg-none">
                                    <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setMobailState(!mobailActive)}>
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li> */}
                                <li>
                                    <a className="ico_btn_outline" href='https://xmagnetic.org/dex/NMA+rf34Lq4Hfcfe1PonfsPBr2pSo62pFvCi6R_XRP+XRP?network=mainnet'>
                                        <span className="btn_label">Buy $NMA</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
 
    )
}

export default Header;